import { puoAccedere } from './utils/permessi';

// Elenco unico dei servizi: lo leggono la banda laterale, la pagina con le schede e i sotto-menu.
// Per aggiungere un servizio basta una riga qui (più la sua sezione di permesso nel backend,
// backend/src/permessi/sezioni.js, quando il servizio esiste davvero).
// - chiave: identificativo
// - nome: testo mostrato all'utente
// - icona: chiave di components/IconaServizio.js
// - percorso: pagina d'ingresso (null = non cliccabile); percorsoCliente se diverso per i clienti
// - sezione: sezione di permesso (null = nessun permesso richiesto); il controllo vero resta sul server
// - destinatari: 'studio' e/o 'cliente'
// - stato: 'attivo' | 'in_arrivo'
// - voci: sotto-menu del servizio (riga in cima al contenuto)
export const SERVIZI = [
  {
    chiave: 'intermittenti',
    nome: 'Intermittenti',
    nomeScheda: 'Attivazione chiamate intermittenti',
    icona: 'chiamata',
    percorso: '/intermittenti',
    percorsoCliente: '/',
    sezione: 'intermittenti',
    destinatari: ['studio', 'cliente'],
    ordine: 1,
    stato: 'attivo',
    voci: [
      { path: '/intermittenti', pathCliente: '/', label: 'Pagina principale' },
      { path: '/clienti', label: 'Aziende', soloStudio: true },
      { path: '/lavoratori', label: 'Lavoratori' },
      { path: '/comunicazioni', label: 'Comunicazioni' },
      { path: '/email', label: 'Email/PEC' },
      { path: '/statistiche', label: 'Statistiche', soloStudio: true },
      // Cestino generale (aziende e lavoratori di Intermittenti, tra le altre cose): per tutti gli operatori dello studio; ognuno vede solo le sezioni permesse (lo decide il server)
      { path: '/cestino', label: 'Cestino', icona: 'cestino', destra: true, soloStudio: true },
    ],
  },
  {
    chiave: 'competenze',
    nome: 'Parcellazione',
    icona: 'euro',
    percorso: '/competenze',
    sezione: 'competenze',
    destinatari: ['studio'],
    ordine: 2,
    stato: 'attivo',
    voci: [
      { path: '/competenze', label: 'Pagina principale' },
      { path: '/competenze/clienti', label: 'Aziende' },
      { path: '/competenze/diciture', label: 'Diciture' },
      { path: '/competenze/listino', label: 'Listino' },
      { path: '/competenze/fatturanti', label: 'Fatturanti', soloAdmin: true },
      { path: '/competenze/tariffe', label: 'Tariffe orarie', soloAdmin: true },
      { path: '/competenze/elenchi', label: 'Elenchi (Tipo F24)', soloAdmin: true },
      { path: '/competenze/impostazioni', label: 'Impostazioni', soloAdmin: true },
      // Cestino: stessa riga, tutto a destra, con icona e numero di elementi
      { path: '/competenze/cestino', label: 'Cestino', icona: 'cestino', destra: true, contatore: '/competenze/cestino/conteggio' },
    ],
  },
  {
    chiave: 'scadenziario',
    nome: 'Scadenziario',
    icona: 'calendario',
    percorso: '/scadenziario',
    sezione: 'scadenziario',
    destinatari: ['studio'],
    ordine: 3,
    stato: 'attivo',
    voci: [
      { path: '/scadenziario', label: 'Pagina principale' },
      { path: '/scadenziario/ditte', label: 'Aziende' },
      { path: '/scadenziario/tipi', label: 'Tipi e categorie' },
      { path: '/scadenziario/codici-unilav', label: 'Codici UNILAV' },
      { path: '/scadenziario/livelli-ccnl', label: 'Livelli CCNL' },
      // Cestino generale (comprende le voci dello Scadenziario): per tutti gli operatori dello studio; ognuno vede solo le sezioni permesse (lo decide il server)
      { path: '/cestino', label: 'Cestino', icona: 'cestino', destra: true },
    ],
  },
  {
    chiave: 'anagrafiche',
    nome: 'Anagrafiche',
    icona: 'anagrafiche',
    percorso: '/anagrafiche',
    sezione: 'anagrafiche',
    destinatari: ['studio'],
    ordine: 0.5,   // primo nella banda e nelle schede, prima di Intermittenti
    descrizione: 'Elenco unico delle aziende, dati comuni a tutti i servizi',
    stato: 'attivo',
    nascostoSenzaPermesso: true,   // visibile solo a chi ha almeno la lettura (gli altri servizi restano con il lucchetto)
    voci: [
      { path: '/anagrafiche', label: 'Pagina principale' },
      { path: '/anagrafiche/cestino', label: 'Cestino', icona: 'cestino', destra: true, contatore: '/anagrafiche/cestino/conteggio' },
    ],
  },
  {
    chiave: 'modello_isa',
    nome: 'Modello ISA',
    icona: 'calcolatrice',
    percorso: null,
    sezione: null,
    destinatari: ['studio'],
    ordine: 4,
    stato: 'in_arrivo',
    voci: [],
  },
  {
    chiave: 'budget',
    nome: 'Budget e Forecast',
    icona: 'grafico',
    percorso: null,
    sezione: null,
    destinatari: ['studio'],
    ordine: 5,
    stato: 'in_arrivo',
    voci: [],
  },
  {
    chiave: 'analisi_investimenti',
    nome: 'Analisi nuovi investimenti',
    icona: 'grafico_salita',
    percorso: null,
    sezione: null,
    destinatari: ['studio'],
    ordine: 6,
    stato: 'in_arrivo',
    voci: [],
  },
];

// Servizi da mostrare all'utente, in ordine, con:
// - consentito: l'utente ha il permesso (almeno lettura); senza sezione è sempre consentito
// - cliccabile: ha una pagina d'ingresso (Modello ISA, Budget e Forecast e Analisi nuovi investimenti per ora no)
// - percorso: quello giusto per il tipo di utente
export function serviziPerUtente(utente, servizi = SERVIZI) {
  if (!utente) return [];
  const cliente = utente.ruolo === 'cliente';
  return servizi
    .filter(s => s.destinatari.includes(utente.ruolo))
    .filter(s => !s.nascostoSenzaPermesso || !s.sezione || puoAccedere(utente, s.sezione))
    .sort((a, b) => a.ordine - b.ordine)
    .map(s => {
      const percorso = cliente && s.percorsoCliente ? s.percorsoCliente : s.percorso;
      return {
        ...s,
        percorso,
        consentito: !s.sezione || puoAccedere(utente, s.sezione),
        cliccabile: Boolean(percorso),
        voci: s.voci
          .filter(v => (!v.soloStudio || !cliente) && (!v.soloAdmin || utente.admin))
          .map(v => (cliente && v.pathCliente ? { ...v, path: v.pathCliente } : v)),
      };
    });
}

// Voci del menu Impostazioni (ingranaggio in fondo alla banda)
export function vociImpostazioni(utente) {
  if (!utente) return [];
  const voci = [{ chiave: 'password', label: 'Cambia password', path: '/cambia-password' }];
  // Il Cestino è per tutti gli operatori dello studio (ognuno vede le sezioni permesse); Utenti e permessi solo per l'admin
  if (utente.ruolo === 'studio') voci.push({ chiave: 'cestino', label: 'Cestino', path: '/cestino' });
  if (utente.admin) voci.push({ chiave: 'utenti', label: 'Utenti e permessi', path: '/utenti', soloAdmin: true });
  return voci;
}

// Servizio a cui appartiene un percorso (per evidenziare la voce attiva); null sulla pagina con le schede
export function servizioDelPercorso(pathname, utente) {
  if (pathname.startsWith('/competenze')) return 'competenze';
  if (pathname.startsWith('/scadenziario')) return 'scadenziario';
  if (pathname.startsWith('/anagrafiche')) return 'anagrafiche';
  if (['/utenti', '/cestino', '/cambia-password', '/accesso-negato'].includes(pathname)) return null;
  if (pathname === '/' && utente?.ruolo === 'studio') return null;
  return 'intermittenti';
}

// Nomi brevi delle sezioni di permesso mostrati nelle tabelle (es. pagina Utenti):
// la chiave interna resta quella del server.
const ETICHETTE_SEZIONI = { competenze: 'Parcellazione' };
export function etichettaSezione(sezione) {
  return ETICHETTE_SEZIONI[sezione.id] || sezione.nome;
}
